import React from 'react';
import { SeoHead } from './components/SeoHead';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Reviews } from './components/Reviews';
import { ClinicGallery } from './components/ClinicGallery';
import { ServicesSection } from './components/ServicesSection';
import { WhyLima } from './components/WhyLima';
import { InvisalignSection } from './components/InvisalignSection';
import { BeforeAfterGallery } from './components/BeforeAfterGallery';
import { EmergencySection } from './components/EmergencySection';
import { FinancingSection } from './components/FinancingSection';
import { DoctorSection } from './components/DoctorSection';
import { PatientInfo } from './components/PatientInfo';
import { BookingSection } from './components/BookingSection';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0" data-mp="3ik7fqfdqo9q4">
      <SeoHead data-id="element-1" data-mp="3ijfu9xduvsdk" />

      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-[8px] focus:bg-white focus:px-4 focus:py-3 focus:text-sm focus:font-medium focus:text-ink" data-id="element-2" data-mp="3ihv0i9zd8dgr">
        Skip to main content
      </a>

      <Header data-id="element-3" data-mp="56mnfkhz7n0" />

      <main id="main-content" data-id="element-4" data-mp="7su7f7e1n58">
        <Hero data-id="element-5" data-mp="2zllen0i82im7" />
        <TrustBar data-id="element-6" data-mp="2zm4y4lnitf2c" />
        <Reviews data-id="element-7" data-mp="2zmo557bmuj1l" />
        <ClinicGallery data-id="element-8" data-mp="2zn6actg9w7ln" />
        <ServicesSection data-id="element-9" data-mp="33mowfsjtyoq2" />
        <WhyLima data-id="element-10" data-mp="33lwzoeehyky7" />
        <InvisalignSection data-id="element-11" data-mp="33nggq77z9011" />
        <BeforeAfterGallery data-id="element-12" data-mp="33orjc3pos1qk" />
        <EmergencySection data-id="element-13" data-mp="38m1fe27kzbnd" />
        <FinancingSection data-id="element-14" data-mp="38kqbm2e4y3w9" />
        <DoctorSection data-id="element-15" data-mp="38kgmsi4tu2s5" />
        <PatientInfo data-id="element-16" data-mp="3dkuv81acbeqp" />
        <BookingSection data-id="element-17" data-mp="3dle3eqa6uorj" />
      </main>

      <Footer data-id="element-18" data-mp="3dmfolnkx4rmz" />
      <MobileStickyBar data-id="element-19" data-mp="3diruonbka37q" />
    </div>;
}